import React from 'react';
import { Box } from '@mui/material';

const chakraPositions = [
  { key: 'crown', top: '28.5%', left: '50%' },
  { key: 'thirdEye', top: '38.5%', left: '50%' },
  { key: 'throat', top: '49.5%', left: '50%' },
  { key: 'heart', top: '56.5%', left: '50%' },
  { key: 'solarPlexus', top: '66.5%', left: '50%' },
  { key: 'sacral', top: '83.5%', left: '50%' },
  { key: 'root', top: '92.5%', left: '50%' }
];

const chakraColors = {
  crown: '#8e24aa',
  thirdEye: '#3949ab',
  throat: '#1e88e5',
  heart: '#43a047',
  solarPlexus: '#fbc02d',
  sacral: '#fb8c00',
  root: '#d32f2f'
};

const ChakraBodyDiagram = ({ onSelectChakra, activeChakraId, onHoverChakra, onLeaveChakra }) => (
  <Box
    sx={{
      position: 'relative',
      width: { xs: 220, sm: 320 },
      height: { xs: 320, sm: 480 },
      mx: 'auto',
      background: 'white',
      borderRadius: 4,
      boxShadow: 6,
      overflow: 'hidden',
      backgroundImage: 'url(/chakra-body-watercolor.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    {chakraPositions.map((chakra) => (
      <Box
        key={chakra.key}
        sx={{
          position: 'absolute',
          top: chakra.top,
          left: chakra.left,
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          cursor: 'pointer',
        }}
        onClick={() => onSelectChakra(chakra.key)}
        onMouseEnter={() => onHoverChakra && onHoverChakra(chakra.key)}
        onMouseLeave={() => onLeaveChakra && onLeaveChakra()}
      >
        <Box
          sx={{
            width: activeChakraId === chakra.key ? 32 : 22,
            height: activeChakraId === chakra.key ? 32 : 22,
            borderRadius: '50%',
            background: chakraColors[chakra.key],
            boxShadow: activeChakraId === chakra.key
              ? `0 0 16px 6px ${chakraColors[chakra.key]}88`
              : `0 0 8px 2px ${chakraColors[chakra.key]}44`,
            border: activeChakraId === chakra.key ? '3px solid white' : '2px solid #fff',
            transition: 'all 0.25s',
            opacity: 0.95
          }}
        />
      </Box>
    ))}
  </Box>
);

export default ChakraBodyDiagram; 